import PageHeader from "../components/PageHeader";
import TigerDraw from "../components/TigerDraw";
import { INVOCATION, MANIFESTO, TONALITY } from "../data/content";
import { FadeUp, SectionTag } from "../components/Motion";
import { DotStrip } from "../components/Brand";

const Philosophy = () => (
  <>
    <PageHeader
      tag="Brand philosophy — The Nexa manifesto"
      title={
        <>
          Six chapters.<br />
          <span className="text-nexa-red">Zero apologies.</span>
        </>
      }
      sub="This is the operating system every Nexa brief runs on. Read it before you hire us — it tells you exactly what you're buying."
    />

    <section className="border-b border-white/10 bg-nexa-surface/40" data-testid="invocation-section">
      <div className="mx-auto grid max-w-[1600px] items-center gap-12 px-5 py-24 md:grid-cols-12 md:px-10 md:py-32">
        <div className="md:col-span-8">
          <SectionTag>{INVOCATION.kicker}</SectionTag>
          <FadeUp>
            <h2 className="mt-6 max-w-5xl font-display text-5xl uppercase leading-[0.95] tracking-tight text-nexa-bone sm:text-6xl lg:text-8xl">
              {INVOCATION.title}
              <br />
              <span className="text-nexa-red">{INVOCATION.sub}</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.15}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-nexa-bone/60 md:text-lg">{INVOCATION.body}</p>
          </FadeUp>
        </div>
        <FadeUp delay={0.25} className="md:col-span-4">
          <div className="rotate-2 border border-white/15 bg-nexa-red p-3 shadow-[10px_10px_0_0_rgba(0,0,0,0.45)]" data-testid="invocation-tiger">
            <TigerDraw n={3} className="h-auto w-full" startDelay={0.4} />
          </div>
        </FadeUp>
      </div>
    </section>

    <section className="mx-auto max-w-[1600px] px-5 py-24 md:px-10" data-testid="manifesto-chapters">
      {MANIFESTO.map((ch, i) => (
        <FadeUp key={ch.num}>
          <div
            className={`grid gap-6 py-16 md:grid-cols-12 ${i !== 0 ? "border-t border-white/10" : ""} ${
              i % 2 === 1 ? "md:text-left" : ""
            }`}
            data-testid={`manifesto-chapter-${ch.num}`}
          >
            <div className="md:col-span-3">
              <span className="font-display text-7xl leading-none text-nexa-red md:text-8xl">{ch.num}</span>
            </div>
            <div className="md:col-span-9">
              <h2 className="max-w-4xl font-display text-4xl uppercase leading-[0.95] tracking-tight text-nexa-bone sm:text-5xl lg:text-7xl">
                {ch.title}
              </h2>
              <p className="mt-6 max-w-2xl text-base leading-relaxed text-nexa-bone/60 md:text-lg">{ch.body}</p>
            </div>
          </div>
        </FadeUp>
      ))}
    </section>

    <DotStrip className="text-nexa-red/70" />

    <section className="mx-auto max-w-[1600px] px-5 py-24 md:px-10" data-testid="tonality-section">
      <SectionTag>Tonality — How Nexa speaks</SectionTag>
      <h2 className="mt-4 font-display text-5xl uppercase leading-none text-nexa-bone md:text-7xl">
        Loud visuals.<br />
        <span className="text-nexa-red">Measured words.</span>
      </h2>
      <div className="mt-14 grid gap-5 md:grid-cols-2">
        {TONALITY.principles.map((p, i) => (
          <FadeUp key={p.title} delay={i * 0.08}>
            <div className="h-full border border-white/10 bg-nexa-surface p-8 transition-colors duration-300 hover:border-nexa-red" data-testid={`tonality-card-${i}`}>
              <span className="font-mono text-xs tracking-[0.25em] text-nexa-red">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-4 font-display text-2xl uppercase text-nexa-bone md:text-3xl">{p.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-nexa-bone/60">{p.body}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </section>
  </>
);

export default Philosophy;
